import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditRegionCountryMasterPage = withSuspense(lazy(() => import('./edit-region-country-master-page')));
export default EditRegionCountryMasterPage;
